class PrimeCostPlusProjectViewController {
  constructor() {
    'ngInject';
  }
}

export default PrimeCostPlusProjectViewController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/prime-cost-plus-project-view/prime-cost-plus-project-view.controller.js